import { IEmailFamily } from "./email-family";
import { IEmailType } from "./email-type";
import { IEmailExcelId } from "./email-excel-id";

export interface IEmail {
    id: number;
    emailTemplateId: number;
    emailFamily: IEmailFamily;
    emailType: IEmailType;
    emailExcelId: IEmailExcelId;
}